var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var Link = require('react-router').Link;
var Billboard = require('../../education/components/layout/billboard.jsx');
var TrialListItem = require('./layout/trialListItem.jsx');

var TrialList = createReactClass({
	mixins: [PureRenderMixin],

  getInitialState: function () {
    const { page = 1 } = this.props.params;
    return {
      currentPage: page,
      filterTerm: "",
    };
  },

    componentDidMount: function() {
      const { page = 1 } = this.props.params;
      this.props.fetchTrialsIfNeeded(page);
    },

    componentDidUpdate: function(prevProps) {
      // If page changes, refetch
      if (this.props.params !== prevProps.params) {
        const { page = 1 } = this.props.params;
        const { filterTerm } = this.state;
        this.setState(Object.assign({}, this.state, { currentPage: page }));
        this.props.fetchTrialsIfNeeded(page, filterTerm);
      }
    },

    hasDataLoaded: function(){
      return !this.props.trials.isFetching;
    },

    handleChange: function(event) {
      const { page = 1 } = this.props.params;
      const filterTerm = event.target.value;
      this.setState(Object.assign({}, this.state, { filterTerm }));
      this.props.fetchTrialsIfNeeded(page, filterTerm);
    },

    renderPageNumbers: function() {
      // Always show first 2 and last 2 pages; Middle pages are dynamic +/-2
      let fields = [];
      const { totalCount } = this.props.trials;
      const { currentPage } = this.state;
      const lastPage = Math.ceil(totalCount / 10);

      for (var index = 1; index < (lastPage + 1); index++) {
        let item;
        const classes = parseInt(currentPage, 10) === index ? 'current' : '';
        if (
          index <= 2 ||
          (index >=  parseInt(currentPage, 10) - 2 && index <=  parseInt(currentPage, 10) + 2) ||
          index >= lastPage - 1
        ) {
          if (parseInt(currentPage, 10) === index) {
            item = <li key={index} className={classes}>{index}</li>
          } else {
            item = <li key={index} className={classes}><Link to={`/trials/${index}`}>{index}</Link></li>
          }
        }
        fields.push(item)

        // Add ellipsis for beginning and end
        if (
          (index === 2 && parseInt(currentPage, 10) > 4) ||
          (index === (lastPage - 2) && parseInt(currentPage, 10) < (lastPage - 4))
          ) {
            fields.push(<li key={index + 99} className="ellipsis"></li>)
        }
      }
      return fields;
    },

    getContent: function(){
      const { currentPage } = this.state;
      const { totalCount } = this.props.trials;
      const lastPage = Math.ceil(totalCount / 10);
        var trials = this.props.trials.data;
        const trialsList = trials.map((trial) => {
          return <TrialListItem key={trial.NCTNumber} trialData={trial} />
        });

        // Get billboard ad
        // const { ads: adsArray = [] } = disease;
        // const adBillboard = adsArray.find(o => o.type === 'billboard') || {};
        const adBillboard = {
            type: 'billboard',
            imageUrl: 'https://res.cloudinary.com/mytotalhealth/image/upload/v1633126501/ads/CDI_SIBO_Billboard.png',
            linkUrl: 'https://commdx.com/breath-testing-for-sibo-imo/',
        }

        var children = [
            <Helmet
                title="MyGI - Clinical trials"
                meta={[{
                    name: 'description',
                    content: "Clinical trials for GI issues"
                }]}
                key={0} />,
                <div className="content-header-wrapper" key={1}>
                <div className="row column content-header">
                  <h1>Clinical Trials</h1>
                  <p>Find a clinical trial to participate in near you.</p>
                </div>
              </div>,
              <Billboard ad={adBillboard} key={2} />,
              <div className="main-wrapper row" key={3}>
                <div className="content">
                  <p>Welcome to the clinical trials page at MyGI Health! Here, we provide comprehensive information on the latest clinical trials available for patients with gastrointestinal (GI) conditions across the nation. Whether you are searching for a new treatment option, want to be at the forefront of cutting-edge medical research, or simply want to learn more about the trials available, you have come to the right place. Our goal is to provide you with up-to-date information on the clinical trials currently enrolling patients and to assist you in finding a trial that is right for you. Browse through our available trials to learn more about the study objectives, eligibility criteria, and location. Let's work together to find a better future for GI health!</p>
                  <p><strong>Filter trials by:&nbsp;</strong>
                    <select style={{maxWidth: "360px"}} value={this.state.filterTerm} onChange={(e) => this.handleChange(e)}>
                      <option value="All">All</option>
                      <option value="BE">Barrett's Esophagus</option>
                      <option value="CEL">Celiac Disease</option>
                      <option value="CD">Crohn's Disease (CD)</option>
                      <option value="FGI">Functional GI (General)</option>
                      <option value="GERD">Gastroesophageal Reflux Disease (GERD)</option>
                      <option value="GAS">Gastroparesis</option>
                      <option value="IBD">Inflammatory Bowel Disease (IBD)</option>
                      <option value="IBS">Irritable Bowel Syndrome (IBS)</option>
                      <option value="SIBO">Small Intestinal Bacterial Overgrowth (SIBO)</option>
                      <option value="UC">Ulcerative Colitis (UC)</option>
                    </select>
                  </p>
                  <p><strong>{totalCount} trials available</strong></p>

                  {trialsList}

                  <nav aria-label="Pagination">
                    <ul className="pagination text-center">
                      <li className={`pagination-previous ${(parseInt(currentPage, 10) === 1) && 'disabled'}`}>
                        {(parseInt(currentPage, 10) === 1) ?
                        <span>Previous</span> :
                        <Link to={`/trials/${parseInt(currentPage, 10) - 1}`} aria-label="Previous page">Previous</Link>}
                      </li>
                      {this.renderPageNumbers()}
                      <li className={`pagination-next ${(parseInt(currentPage, 10) === lastPage) && 'disabled'}`}>
                        {(parseInt(currentPage, 10) === lastPage) ?
                        <span>Next</span> :
                        <Link to={`/trials/${parseInt(currentPage, 10) + 1}`} aria-label="Previous page">Next</Link>}
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

  render: function () {
    return (
      <div className="content">
                {this.getContent()}
      </div>
    );
  }
});

module.exports = TrialList;



// WEBPACK FOOTER //
// ./src/common/routes/trials/components/trialsList.jsx